export default "__VITE_ASSET__b1f6209a__"